function ZastitaOdPozara() {
  return <>ZastitaOdPozara</>;
}

export default ZastitaOdPozara;
